import React from 'react';
import {
    AdvancedTable,
    AdvancedTableHeader,
    AdvancedTableData,
    Card,
} from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { push } from 'connected-react-router';
import { IPaginationData } from 'components/Pagination/Pagination';
import { connect } from 'react-redux';
import { useLocalErrorHandler } from 'hooks';
import { GetQecListPayload } from '../../redux/models/qec';

const QecListContainer = ({
    setErrorHandler,
    getQecs,
    apiError,
    qecList,
    onPush,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const tableHeaders: AdvancedTableHeader[] = [
        { fieldName: 'regNumber', title: 'ЦОК ID', columnStyles: { minWidth: '8.125rem', whiteSpace: 'nowrap' } },
        { fieldName: 'fullName', title: 'НАЗВАНИЕ', columnStyles: { width: '100%' } },
        { fieldName: 'city', title: 'РЕГИОН', columnStyles: { minWidth: '11.25rem', whiteSpace: 'nowrap' } },
    ];

    const initialSort: GetQecListPayload = {
        searchField: undefined,
        searchTerm: undefined,
        page: undefined,
        pageSize: undefined,
        sortOrder: undefined,
        sortField: undefined,
    };

    const [sort, setSort] = React.useState(initialSort);
    const [firstRun, setFirstRun] = React.useState(true);

    React.useEffect(() => {
        getQecs(sort);
    }, []);

    React.useEffect(() => {
        getQecs(sort);
    }, [sort, firstRun]);

    const handlePageChange = (paginationData: IPaginationData) => setSort({
        ...sort,
        page: paginationData.page,
        pageSize: paginationData.perPage,
    });

    const handleSearch = (fieldName: string, value: string) => {
        setSort({
            ...sort,
            searchField: fieldName,
            searchTerm: value,
        });
        setFirstRun(false);
    };

    const handleOrder = (fieldName: string) => setSort({
        ...sort,
        sortField: fieldName,
        sortOrder: !sort.sortOrder,
    });

    const handleRowClick = (itemId: string) => onPush(`/ec-details/${itemId}`);

    const qualificationToTableData = (): AdvancedTableData[] => (qecList ? qecList.items.map(item => ({
        id: item.id,
        columns: [item.regNumber, item.fullName, item.city],
    })) : []);

    return (
        <Card
          title="Список ЦОК"
          category="Список ЦОК, сотрудничающих с ЭЦ"
          cardClassName="position-relative"
          apiError={apiError}
          withoutBorder
          withoutPadding
        >
            <AdvancedTable
              data={qualificationToTableData()}
              tableHeaders={tableHeaders}
              handlePageChange={handlePageChange}
              handleOrder={handleOrder}
              handleRowClick={handleRowClick}
              handleSearch={handleSearch}
              pageSize={(qecList && qecList.pageSize) || 10}
              total={(qecList && qecList.total) || 1}
              page={(qecList && qecList.page) || 1}
              placeholderTitle="Список ЦОК недоступен"
            />
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    qecList: state.qec.qecList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    getQecs: dispatch.qec.getQecsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(QecListContainer);

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
